<template>
<div>
    <header>
        <h1>Registrieren</h1>
    </header>
    <p>
        E-Mail-Adresse wird überprüft...
    </p>
</div>
</template>

<script>
import base from 'base.vue'

export default {
    mixins: [ base ],
    data () {
        return { }
    },
    methods: {
        fetchData () {
            const that = this

            return this.$api.post('confirm-email', { token: this.route.params.token })
            .then(response => {
                response.data.user.api_token = response.data.api_token
                window.store.commit('login', response.data.user)
                window.router.push('/')
            })
            .catch(error => {
                window.flash('Es ist ein Fehler aufgetreten', 'error', {
                    important: true
                })
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// confirm-email.vue?143b3760